import { WidgetSize } from 'shared/constants/widgets'

const VALID_SIZES = new Set<string>(Object.values(WidgetSize))

export const resolveArtifactSize = (defaultSize?: string): WidgetSize =>
  defaultSize && VALID_SIZES.has(defaultSize)
    ? (defaultSize as WidgetSize)
    : WidgetSize.MEDIUM
